import { useContext, useMemo } from 'react'
import UserContext from '../../context/UserContext'

export const useDefaultConf = () => {
    const token = useContext(UserContext)

    return useMemo(() => ({
        headers: {
            "ttid": token.user_email,
            "triage-app": "ControlCenter",
            "triage-app-version": process.env.REACT_APP_VERSION
        }
    }), [token.user_email])
}
